export default __webpack_public_path__ + "static/media/insurance_provider.a6e65204.svg";